import {PinInput as ChakraPinInput, PinInputProps} from '@chakra-ui/react'

export const PinInput = (props: PinInputProps) => {
  return <ChakraPinInput {...props}></ChakraPinInput>
}
export default PinInput
